'use client';
import React, { useEffect } from 'react';
import styled from '@benzinga/themetron';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { Icon } from '@benzinga/core-ui';

const Loader = ({ loading }: { loading: boolean }) => {
  const [isLoading, setLoading] = React.useState(loading);

  useEffect(() => setLoading(loading), [loading]);

  return isLoading ? (
    <LoaderWrapper className="loader-wrapper">
      <Icon className="loader-wrapper__loader" icon={faSpinner} />
    </LoaderWrapper>
  ) : null;
};

export default Loader;

const LoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  .loader-wrapper__loader {
    position: absolute;
    color: ${props => props.theme.colorPalette.blue700};
    font-size: 30px;
    animation: 1s spin infinite linear;
    transform-origin: center;
  }
`;
